module.exports = __webpack_public_path__ + "static/media/smile.b9dd76c3.svg";